import asset from "../images/asset.jpg";
export const Style = {
  background: `linear-gradient(to bottom, #e1bef1CC, #f3f6f7CC),  url(${asset})`,
  backgroundSize: `100%`,
};
